import BaseURL from "./images/Hosting-BaseURL";

import goblinUnits from "./Goblins";
import orcUnits from "./Orcs";
import { shadowTypes } from "../styles/UnitShadow";

const vadervaldImage = `${BaseURL}/Special/Christmas/Vadervald.png`;
const vadervaldPreviewImage = `${BaseURL}/Special/Christmas/previews/Vadervald.png`;

const farfergrisOnBoarImage = `${BaseURL}/Special/Christmas/Farfergris on Boar.png`;
const farfergrisOnBoarPreviewImage = `${BaseURL}/Special/Christmas/previews/Farfergris on Boar.png`;

const farfergrisImage = `${BaseURL}/Special/Christmas/Farfergris.png`;
const farfergrisPreviewImage = `${BaseURL}/Special/Christmas/previews/Farfergris.png`;

const bigboarImage = `${BaseURL}/Special/Christmas/Bigboar.png`;
const bigboarPreviewImage = `${BaseURL}/Special/Christmas/previews/Bigboar.png`;

const toyKnightAImage = `${BaseURL}/Special/Christmas/Toy Knight A.png`;
const toyKnightBImage = `${BaseURL}/Special/Christmas/Toy Knight B.png`;
const toyKnightCImage = `${BaseURL}/Special/Christmas/Toy Knight C.png`;
const toyKnightDImage = `${BaseURL}/Special/Christmas/Toy Knight D.png`;
const toyKnightAPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Knight A.png`;
const toyKnightBPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Knight B.png`;
const toyKnightCPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Knight C.png`;
const toyKnightDPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Knight D.png`;

const toyClericAImage = `${BaseURL}/Special/Christmas/Toy Cleric A.png`;
const toyClericBImage = `${BaseURL}/Special/Christmas/Toy Cleric B.png`;
const toyClericCImage = `${BaseURL}/Special/Christmas/Toy Cleric C.png`;
const toyClericDImage = `${BaseURL}/Special/Christmas/Toy Cleric D.png`;
const toyClericAPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Cleric A.png`;
const toyClericBPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Cleric B.png`;
const toyClericCPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Cleric C.png`;
const toyClericDPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Cleric D.png`;

const toyRangerAImage = `${BaseURL}/Special/Christmas/Toy Ranger A.png`;
const toyRangerBImage = `${BaseURL}/Special/Christmas/Toy Ranger B.png`;
const toyRangerCImage = `${BaseURL}/Special/Christmas/Toy Ranger C.png`;
const toyRangerDImage = `${BaseURL}/Special/Christmas/Toy Ranger D.png`;
const toyRangerAPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Ranger A.png`;
const toyRangerBPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Ranger B.png`;
const toyRangerCPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Ranger C.png`;
const toyRangerDPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Ranger D.png`;

const toyRogueAImage = `${BaseURL}/Special/Christmas/Toy Rogue A.png`;
const toyRogueBImage = `${BaseURL}/Special/Christmas/Toy Rogue B.png`;
const toyRogueCImage = `${BaseURL}/Special/Christmas/Toy Rogue C.png`;
const toyRogueDImage = `${BaseURL}/Special/Christmas/Toy Rogue D.png`;
const toyRogueAPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Rogue A.png`;
const toyRogueBPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Rogue B.png`;
const toyRogueCPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Rogue C.png`;
const toyRogueDPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Rogue D.png`;

const toyWizardAImage = `${BaseURL}/Special/Christmas/Toy Wizard A.png`;
const toyWizardBImage = `${BaseURL}/Special/Christmas/Toy Wizard B.png`;
const toyWizardCImage = `${BaseURL}/Special/Christmas/Toy Wizard C.png`;
const toyWizardDImage = `${BaseURL}/Special/Christmas/Toy Wizard D.png`;
const toyWizardAPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Wizard A.png`;
const toyWizardBPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Wizard B.png`;
const toyWizardCPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Wizard C.png`;
const toyWizardDPreviewImage = `${BaseURL}/Special/Christmas/previews/Toy Wizard D.png`;

const present1AImage = `${BaseURL}/Special/Christmas/Present 1 A.png`;
const present1BImage = `${BaseURL}/Special/Christmas/Present 1 B.png`;
const present1CImage = `${BaseURL}/Special/Christmas/Present 1 C.png`;
const present1DImage = `${BaseURL}/Special/Christmas/Present 1 D.png`;
const present1APreviewImage = `${BaseURL}/Special/Christmas/previews/Present 1 A.png`;
const present1BPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 1 B.png`;
const present1CPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 1 C.png`;
const present1DPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 1 D.png`;

const present2AImage = `${BaseURL}/Special/Christmas/Present 2 A.png`;
const present2BImage = `${BaseURL}/Special/Christmas/Present 2 B.png`;
const present2CImage = `${BaseURL}/Special/Christmas/Present 2 C.png`;
const present2DImage = `${BaseURL}/Special/Christmas/Present 2 D.png`;
const present2APreviewImage = `${BaseURL}/Special/Christmas/previews/Present 2 A.png`;
const present2BPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 2 B.png`;
const present2CPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 2 C.png`;
const present2DPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 2 D.png`;

const present3AImage = `${BaseURL}/Special/Christmas/Present 3 A.png`;
const present3BImage = `${BaseURL}/Special/Christmas/Present 3 B.png`;
const present3CImage = `${BaseURL}/Special/Christmas/Present 3 C.png`;
const present3DImage = `${BaseURL}/Special/Christmas/Present 3 D.png`;
const present3APreviewImage = `${BaseURL}/Special/Christmas/previews/Present 3 A.png`;
const present3BPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 3 B.png`;
const present3CPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 3 C.png`;
const present3DPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 3 D.png`;

const present4AImage = `${BaseURL}/Special/Christmas/Present 4 A.png`;
const present4BImage = `${BaseURL}/Special/Christmas/Present 4 B.png`;
const present4CImage = `${BaseURL}/Special/Christmas/Present 4 C.png`;
const present4DImage = `${BaseURL}/Special/Christmas/Present 4 D.png`;
const present4APreviewImage = `${BaseURL}/Special/Christmas/previews/Present 4 A.png`;
const present4BPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 4 B.png`;
const present4CPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 4 C.png`;
const present4DPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 4 D.png`;

const present5AImage = `${BaseURL}/Special/Christmas/Present 5 A.png`;
const present5BImage = `${BaseURL}/Special/Christmas/Present 5 B.png`;
const present5CImage = `${BaseURL}/Special/Christmas/Present 5 C.png`;
const present5DImage = `${BaseURL}/Special/Christmas/Present 5 D.png`;
const present5APreviewImage = `${BaseURL}/Special/Christmas/previews/Present 5 A.png`;
const present5BPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 5 B.png`;
const present5CPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 5 C.png`;
const present5DPreviewImage = `${BaseURL}/Special/Christmas/previews/Present 5 D.png`;

const snowman1Image = `${BaseURL}/Special/Christmas/Snowman 1.png`;
const snowman1PreviewImage = `${BaseURL}/Special/Christmas/previews/Snowman 1.png`;

const snowman2Image = `${BaseURL}/Special/Christmas/Snowman 2.png`;
const snowman2PreviewImage = `${BaseURL}/Special/Christmas/previews/Snowman 2.png`;

const snowman3Image = `${BaseURL}/Special/Christmas/Snowman 3.png`;
const snowman3PreviewImage = `${BaseURL}/Special/Christmas/previews/Snowman 3.png`;

const snowman4Image = `${BaseURL}/Special/Christmas/Snowman 4.png`;
const snowman4PreviewImage = `${BaseURL}/Special/Christmas/previews/Snowman 4.png`;

const snowman5Image = `${BaseURL}/Special/Christmas/Snowman 5.png`;
const snowman5PreviewImage = `${BaseURL}/Special/Christmas/previews/Snowman 5.png`;

const sackGoblinImage = `${BaseURL}/Special/Christmas/Sack Goblin.png`;
const sackGoblinPreviewImage = `${BaseURL}/Special/Christmas/previews/Sack Goblin.png`;

export const christmasTagFilter = (variant) => variant.tags.includes("christmas");

const mapDisableRestrictions = (variant) => ({
    ...variant,
    // Seasonal Free Mode
    // legendary: false,
    // previewSrc: null,
});

const mapFreeChristmasVariants = (unit) => ({
    ...unit,
    variants: unit.variants
        .filter(christmasTagFilter)
        .map(mapDisableRestrictions),
});

export default [
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "5px",
            right: "13px",
        },
        variants: [
            {
                variant: "",
                unitNumber: "",
                filePrefix: "Farfergris on Boar",
                src: farfergrisOnBoarImage,
                previewSrc: farfergrisOnBoarPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "demon",
                    "christmas",
                    "animal",
                    "boar",
                    "brown",
                    "red",
                    "torch",
                ],
            },
            {
                variant: "",
                unitNumber: "",
                filePrefix: "Farfergris",
                src: farfergrisImage,
                previewSrc: farfergrisPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "demon",
                    "christmas",
                    "red",
                    "stein",
                ],
            },
            {
                variant: "",
                unitNumber: "",
                filePrefix: "Bigboar",
                src: bigboarImage,
                previewSrc: bigboarPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "animal",
                    "christmas",
                    "boar",
                    "brown",
                    "torch",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "-11px",
            right: "27px",
        },
        variants: [
            {
                variant: "",
                unitNumber: "",
                filePrefix: "Vadervald",
                src: vadervaldImage,
                previewSrc: vadervaldPreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "demon",
                    "christmas",
                    "green",
                    "magic",
                    "tome",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "14px",
            right: "31px",
        },
        variants: [
            {
                variant: "",
                unitNumber: "",
                filePrefix: "Sack Goblin",
                src: sackGoblinImage,
                previewSrc: sackGoblinPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "christmas",
                    "red",
                    "green",
                    "present",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "26px",
            right: "45px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "",
                filePrefix: "Toy Knight",
                src: toyKnightAImage,
                previewSrc: toyKnightAPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "armor",
                    "weapon",
                    "sword",
                    "shield",
                    "red",
                    "grey",
                ],
            },
            {
                variant: "B",
                unitNumber: "",
                filePrefix: "Toy Knight",
                src: toyKnightBImage,
                previewSrc: toyKnightBPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "armor",
                    "weapon",
                    "sword",
                    "shield",
                    "green",
                    "grey",
                ],
            },
            {
                variant: "C",
                unitNumber: "",
                filePrefix: "Toy Knight",
                src: toyKnightCImage,
                previewSrc: toyKnightCPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "armor",
                    "weapon",
                    "sword",
                    "shield",
                    "yellow",
                    "grey",
                ],
            },
            {
                variant: "D",
                unitNumber: "",
                filePrefix: "Toy Knight",
                src: toyKnightDImage,
                previewSrc: toyKnightDPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "armor",
                    "weapon",
                    "sword",
                    "shield",
                    "blue",
                    "grey",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "26px",
            right: "45px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "",
                filePrefix: "Toy Cleric",
                src: toyClericAImage,
                previewSrc: toyClericAPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "armor",
                    "weapon",
                    "hammer",
                    "shield",
                    "red",
                    "grey",
                ],
            },
            {
                variant: "B",
                unitNumber: "",
                filePrefix: "Toy Cleric",
                src: toyClericBImage,
                previewSrc: toyClericBPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "armor",
                    "weapon",
                    "hammer",
                    "shield",
                    "green",
                    "grey",
                ],
            },
            {
                variant: "C",
                unitNumber: "",
                filePrefix: "Toy Cleric",
                src: toyClericCImage,
                previewSrc: toyClericCPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "armor",
                    "weapon",
                    "hammer",
                    "shield",
                    "yellow",
                    "grey",
                ],
            },
            {
                variant: "D",
                unitNumber: "",
                filePrefix: "Toy Cleric",
                src: toyClericDImage,
                previewSrc: toyClericDPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "armor",
                    "weapon",
                    "hammer",
                    "shield",
                    "blue",
                    "grey",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "26px",
            right: "45px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "",
                filePrefix: "Toy Ranger",
                src: toyRangerAImage,
                previewSrc: toyRangerAPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "leather",
                    "weapon",
                    "bow",
                    "ranged",
                    "red",
                ],
            },
            {
                variant: "B",
                unitNumber: "",
                filePrefix: "Toy Ranger",
                src: toyRangerBImage,
                previewSrc: toyRangerBPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "leather",
                    "weapon",
                    "bow",
                    "ranged",
                    "green",
                ],
            },
            {
                variant: "C",
                unitNumber: "",
                filePrefix: "Toy Ranger",
                src: toyRangerCImage,
                previewSrc: toyRangerCPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "leather",
                    "weapon",
                    "bow",
                    "ranged",
                    "yellow",
                ],
            },
            {
                variant: "D",
                unitNumber: "",
                filePrefix: "Toy Ranger",
                src: toyRangerDImage,
                previewSrc: toyRangerDPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "leather",
                    "weapon",
                    "bow",
                    "ranged",
                    "blue",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "26px",
            right: "45px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "",
                filePrefix: "Toy Rogue",
                src: toyRogueAImage,
                previewSrc: toyRogueAPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "leather",
                    "weapon",
                    "dagger",
                    "red",
                ],
            },
            {
                variant: "B",
                unitNumber: "",
                filePrefix: "Toy Rogue",
                src: toyRogueBImage,
                previewSrc: toyRogueBPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "leather",
                    "weapon",
                    "dagger",
                    "green",
                ],
            },
            {
                variant: "C",
                unitNumber: "",
                filePrefix: "Toy Rogue",
                src: toyRogueCImage,
                previewSrc: toyRogueCPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "leather",
                    "weapon",
                    "dagger",
                    "yellow",
                ],
            },
            {
                variant: "D",
                unitNumber: "",
                filePrefix: "Toy Rogue",
                src: toyRogueDImage,
                previewSrc: toyRogueDPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "leather",
                    "weapon",
                    "dagger",
                    "blue",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "26px",
            right: "45px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "",
                filePrefix: "Toy Wizard",
                src: toyWizardAImage,
                previewSrc: toyWizardAPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "cloth",
                    "weapon",
                    "staff",
                    "magic",
                    "red",
                ],
            },
            {
                variant: "B",
                unitNumber: "",
                filePrefix: "Toy Wizard",
                src: toyWizardBImage,
                previewSrc: toyWizardBPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "cloth",
                    "weapon",
                    "staff",
                    "magic",
                    "green",
                ],
            },
            {
                variant: "C",
                unitNumber: "",
                filePrefix: "Toy Wizard",
                src: toyWizardCImage,
                previewSrc: toyWizardCPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "cloth",
                    "weapon",
                    "staff",
                    "magic",
                    "yellow",
                ],
            },
            {
                variant: "D",
                unitNumber: "",
                filePrefix: "Toy Wizard",
                src: toyWizardDImage,
                previewSrc: toyWizardDPreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "cloth",
                    "weapon",
                    "staff",
                    "magic",
                    "blue",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "31px",
            right: "45px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "Present",
                src: present1AImage,
                previewSrc: present1APreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "green",
                    "red",
                ],
            },
            {
                variant: "B",
                unitNumber: "1",
                filePrefix: "Present",
                src: present1BImage,
                previewSrc: present1BPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "green",
                    "white",
                ],
            },
            {
                variant: "C",
                unitNumber: "1",
                filePrefix: "Present",
                src: present1CImage,
                previewSrc: present1CPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "green",
                    "red",
                ],
            },
            {
                variant: "D",
                unitNumber: "1",
                filePrefix: "Present",
                src: present1DImage,
                previewSrc: present1DPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "green",
                    "white",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "26px",
            right: "48px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "2",
                filePrefix: "Present",
                src: present2AImage,
                previewSrc: present2APreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "blue",
                    "yellow",
                ],
            },
            {
                variant: "B",
                unitNumber: "2",
                filePrefix: "Present",
                src: present2BImage,
                previewSrc: present2BPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "blue",
                    "yellow",
                ],
            },
            {
                variant: "C",
                unitNumber: "2",
                filePrefix: "Present",
                src: present2CImage,
                previewSrc: present2CPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "green",
                    "yellow",
                ],
            },
            {
                variant: "D",
                unitNumber: "2",
                filePrefix: "Present",
                src: present2DImage,
                previewSrc: present2DPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "green",
                    "yellow",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "37px",
            right: "60px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "3",
                filePrefix: "Present",
                src: present3AImage,
                previewSrc: present3APreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "green",
                    "yellow",
                ],
            },
            {
                variant: "B",
                unitNumber: "3",
                filePrefix: "Present",
                src: present3BImage,
                previewSrc: present3BPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "red",
                    "white",
                ],
            },
            {
                variant: "C",
                unitNumber: "3",
                filePrefix: "Present",
                src: present3CImage,
                previewSrc: present3CPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "red",
                    "white",
                ],
            },
            {
                variant: "D",
                unitNumber: "3",
                filePrefix: "Present",
                src: present3DImage,
                previewSrc: present3DPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "green",
                    "yellow",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "26px",
            right: "48px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "4",
                filePrefix: "Present",
                src: present4AImage,
                previewSrc: present4APreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "red",
                    "white",
                ],
            },
            {
                variant: "B",
                unitNumber: "4",
                filePrefix: "Present",
                src: present4BImage,
                previewSrc: present4BPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "blue",
                    "yellow",
                ],
            },
            {
                variant: "C",
                unitNumber: "4",
                filePrefix: "Present",
                src: present4CImage,
                previewSrc: present4CPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "blue",
                    "yellow",
                ],
            },
            {
                variant: "D",
                unitNumber: "4",
                filePrefix: "Present",
                src: present4DImage,
                previewSrc: present4DPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "red",
                    "white",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "22px",
            right: "35px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "5",
                filePrefix: "Present",
                src: present5AImage,
                previewSrc: present5APreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "red",
                    "yellow",
                ],
            },
            {
                variant: "B",
                unitNumber: "5",
                filePrefix: "Present",
                src: present5BImage,
                previewSrc: present5BPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "green",
                    "red",
                ],
            },
            {
                variant: "C",
                unitNumber: "5",
                filePrefix: "Present",
                src: present5CImage,
                previewSrc: present5CPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "green",
                    "red",
                ],
            },
            {
                variant: "D",
                unitNumber: "5",
                filePrefix: "Present",
                src: present5DImage,
                previewSrc: present5DPreviewImage,
                legendary: true,
                tags: [
                    "mimic",
                    "christmas",
                    "present",
                    "red",
                    "yellow",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "28px",
            right: "39px",
        },
        variants: [
            {
                variant: "",
                unitNumber: "1",
                filePrefix: "Snowman",
                src: snowman1Image,
                previewSrc: snowman1PreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "magic",
                    "snowman",
                    "white",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "29px",
            right: "35px",
        },
        variants: [
            {
                variant: "",
                unitNumber: "2",
                filePrefix: "Snowman",
                src: snowman2Image,
                previewSrc: snowman2PreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "magic",
                    "snowman",
                    "white",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "28px",
            right: "49px",
        },
        variants: [
            {
                variant: "",
                unitNumber: "3",
                filePrefix: "Snowman",
                src: snowman3Image,
                previewSrc: snowman3PreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "magic",
                    "snowman",
                    "white",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "15px",
            right: "31px",
        },
        variants: [
            {
                variant: "",
                unitNumber: "4",
                filePrefix: "Snowman",
                src: snowman4Image,
                previewSrc: snowman4PreviewImage,
                legendary: true,
                tags: [
                    "christmas",
                    "golem",
                    "magic",
                    "snowman",
                    "white",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "5px",
            right: "46px",
        },
        variants: [
            {
                variant: "",
                unitNumber: "5",
                filePrefix: "Snowman",
                src: snowman5Image,
                previewSrc: snowman5PreviewImage,
                legendary: true,
                isExtraLarge: true,
                tags: [
                    "christmas",
                    "golem",
                    "magic",
                    "snowman",
                    "white",
                ],
            },
        ]
    },
]
.concat(
    JSON.parse(JSON.stringify(goblinUnits))
        .filter(goblinUnit => goblinUnit.variants.some(christmasTagFilter)),
    JSON.parse(JSON.stringify(orcUnits))
        .filter(orcUnit => orcUnit.variants.some(christmasTagFilter)),
)
.map(mapFreeChristmasVariants);
